import GeoProvider from '../../components/GeoProvider'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useRequest from '../../utils/useRequest'
import NotFound from '../NotFound'
import { startDate, endDate, displayDate } from './dates'
import dataDisplayOptions from './dataDisplayOptions'
import FluMap from './FluMap'
import styles from './FluMeter.module.scss'
import InitReactorCX from '../../components/Reactor/optumReactorCX' 

const MASKED_VALUE = '********'

const FluMeter = () => {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const frameId = params.get('frameid')
  const clientId = params.get('clientid')
  const hasParams = Boolean(frameId && clientId)

  const { data: isValid, error } = useRequest(
    hasParams && {
      baseURL: process.env.REACT_APP_BFF_BASE_URL || '',
      url: '/api/flumeter/validateurl',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: { clientId, frameId },
      withCredentials: true,
    }
  )

  useEffect(() => {
    if (isValid !== true) return
    // Mask real values in the address bar only; replaceState does not reload or notify the router
    const url = new URL(window.location.href)
    url.searchParams.set('clientid', MASKED_VALUE)
    url.searchParams.set('frameid', MASKED_VALUE)
    window.history.replaceState(window.history.state, '', url.toString())
  }, [isValid])

  if (!hasParams) {
    return <NotFound />
  }

  if (error || isValid === false) {
    return (
      <div className={styles.base}>
        <div className={styles.heading}>
          <h4>Unauthorized access</h4>
        </div>
      </div>
    )
  }

  if (isValid !== true) {
    return <div className={styles.base}>Loading...</div>
  }

  return <FluMeterContent />
}

const FluMeterContent = () => {
  // const { user } = useAuthState()
  useEffect(() => {
    InitReactorCX();
  },[]);

  const location = useLocation();
  const NAMESPACE_OPTUM_REACTOR = process.env.REACT_APP_NAMESPACE_OPTUM_REACTOR;

  useEffect(() => {
    if (location.pathname.length > 1) {
      const custom_data_object = {"namespace": NAMESPACE_OPTUM_REACTOR, "application_viewUrl": location.pathname}
      if (typeof window !== 'undefined' && window.hasOwnProperty("Rakanto") && window.Rakanto.hasOwnProperty('event')) {
        window.Rakanto.event("sendCustomData", custom_data_object);
      }
    }
  }, [location]);

  var url = window.location.href
  var name = 'Flu Meter'
  if (url.indexOf('flumeter') !== -1) name = 'Flu Meter'

  return (
    <div className={styles.base}>
      <div className={styles.heading}>
        <h4>Flu Activity Outlook</h4>
       
      </div>
      <GeoProvider
        startDate={startDate}
        endDate={endDate}
        displayDate={displayDate}
        mapOptions={dataDisplayOptions[0]['options'][0]}
        indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
        regionSelected={'msa'}
      >
        <FluMap />
      </GeoProvider>
      <div className={styles.footer}>
        <p>
        The content, forecasts, and predictions offered may be AI-generated and 
              are for informational purposes only, and nothing in the forecasts, 
              predictions and related information should be considered,
              or used as a substitute for, medical advice, diagnosis or treatment. Users
              should seek the advice of a physician or other qualified health
              care provider with any questions regarding personal health or
              medical conditions. Optum and its affiliates and licensors make no
              representations or warranties of any kind, express or implied,
              with respect to these forecasts, predictions, any related data,
              and/or the techniques used to create such forecasts and
              predictions, including, but not limited to, any warranties of
              performance, merchantability, fitness for a particular purpose,
              title/non-infringement, and quality, accuracy and/or completeness
              of these forecasts, predictions, and related information. Any
              interpretation or use of these forecasts, predictions, and related
              information is solely and exclusively at your own discretion and
              risk, and Optum and its affiliates and licensors will have no
              liability for any damages or claims relating to such
              interpretation or use.
        </p>
      </div>
    </div>
  )
}

export default FluMeter
